module.exports = __webpack_public_path__ + "img/download.3830e309.svg";